import { ACTION_SUBJECT_PREFIX, EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

type ThirdPartyQuerySuggestionsDismissedArgs = {
	productKey: string;
};

export const onThirdPartyQuerySuggestionsDismissed = ({
	productKey,
}: ThirdPartyQuerySuggestionsDismissedArgs): FireAnalyticsEvent => ({
	source: EVENT_SOURCE,
	eventType: 'ui',
	actionSubject: `${ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestions`,
	action: 'dismissed',
	attributes: {
		additionalAttributes: {
			productKey,
		},
	},
});
